import Properties from "./Properties";
import Metadata from "./Metadata";
import Wrapper from "./Wrapper";
import {
  List as CollaboratorsList,
  Add as AddCollaborator
} from "./collaborators";
import Ingestion from "./ingestion";
import Styles from "./Stylesheets";
import Analytics from "./Analytics";
import Sections from "./Sections";
import Section from "./section";
import TableOfContents from "./TableOfContents";
import TOCEntry from "./toc-entry";
import Assets from "./assets";

export default {
  Properties,
  Metadata,
  Wrapper,
  CollaboratorsList,
  AddCollaborator,
  Ingestion,
  Styles,
  Analytics,
  Sections,
  Section,
  TableOfContents,
  TOCEntry,
  Assets
};
